import React, { useState } from 'react'
import { useIntl } from 'react-intl'
// import { AddFolderModal } from '../view/AddFolderModal'
import { toast } from 'react-toastify'
import { updateIsHiddenOrTrash, deleteDataRoomContent } from '../core/_requests'
import { DeleteConfirmationModal } from '../../widgets/components/DeleteConfirmationModal'
// import MoveFolderModal from './data-room-drawer/MoveFolderModal'
import { useMoveToFolderData } from '../core/FileToFolderAuth'
import { ContentTypes } from '../core/_constants'
import { HiddenOrTrash } from '../view/HiddenOrTrashModal'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { useAuth } from '../../auth'
import { useThemeMode } from '../../../../_metronic/partials'

export default function SpaceFileDropdown({
  isOpen,
  contentId,
  parentId,
  getDataRoomContentByparentId,
  getDataRoomContentById,
  type,
  name,
  setMenuOpen,
  addFilesBool,
  is_hidden,
  is_trash,
  dataroom_contentId,
}: {
  isOpen: any
  contentId: number
  parentId: number
  getDataRoomContentByparentId: any
  getDataRoomContentById: any
  type: string
  name: string
  setMenuOpen?: any
  addFilesBool?: boolean
  is_hidden?: any
  is_trash?: any
  dataroom_contentId: number
}) {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  const {
    // setShowDrawer, setFilesContentId,
    setDataRoomLatestBreadcrumbId,
  } = useMoveToFolderData()
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [showDeleteModal, setDeleteShowModal] = useState<number | null>(null)
  const [showHiddenModal, setShowHiddenModal] = useState<number | null>(null)
  const [showTrashModal, setShowTrashModal] = useState<number | null>(null)
  const [isHidden, setIsHidden] = useState<boolean>(false)
  const [hiddenMoving, setHiddenMoving] = useState<boolean>(false)
  const [trashMoving, setTrashMoving] = useState<boolean>(false)
  const { currentUser, companyId } = useAuth()

  // const handleDeleteContent = async () => {
  //   try {
  //     setDeleteLoading(true)
  //     if (contentId) {
  //       const {
  //         data: {success, errors},
  //       } = await deleteFolder(+contentId)
  //       if (success) {
  //         setDeleteShowModal(null)
  //         getDataRoomContentById()
  //         getDataRoomContentByparentId(+parentId)
  //         toast.success(formatMessage({id: 'Deleted successfully'}))
  //       } else {
  //         errors.forEach((error: string) => {
  //           toast.error(formatMessage({id: error}))
  //         })
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err)
  //   } finally {
  //     setDeleteLoading(false)
  //   }
  // }

  const handleDeleteContentDr = async () => {
    try {
      setDeleteLoading(true)
      if (contentId) {
        const {
          data: { success, errors },
        } = await deleteDataRoomContent(dataroom_contentId)
        if (success) {
          setDeleteShowModal(null)
          getDataRoomContentById()
          getDataRoomContentByparentId(null)
          setDataRoomLatestBreadcrumbId(null)
          toast.success(formatMessage({ id: 'Deleted successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteDataRoomContentSuccessful,
              action: 'normal',
              metadata: {
                dataroom_content_id: dataroom_contentId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteDataRoomContentFailed,
              action: 'normal',
              metadata: {
                dataroom_content_id: dataroom_contentId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setDeleteLoading(false)
    }
  }

  const handleHidden = async () => {
    try {
      setHiddenMoving(true)
      if (contentId) {
        const {
          data: { success, errors },
        } = await updateIsHiddenOrTrash(
          dataroom_contentId,
          is_hidden !== 'all' ? false : true,
          false
        )
        if (success) {
          getDataRoomContentByparentId()
          if (is_hidden === 'all') {
            toast.success(formatMessage({ id: 'Moved to hidden successfully' }))
          } else {
            toast.success(formatMessage({ id: 'Moved to all files successfully' }))
          }
          setShowHiddenModal(null)
          getDataRoomContentById()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DataRoomContentIsHiddenSuccessful,
              action: 'normal',
              metadata: {
                dataroom_content_id: dataroom_contentId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                dataroom_content_is_hidden: is_hidden !== 'all' ? false : true,
                company_id: companyId,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DataRoomContentIsHiddenFailed,
              action: 'normal',
              metadata: {
                dataroom_content_id: dataroom_contentId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                dataroom_content_is_hidden: is_hidden !== 'all' ? false : true,
                company_id: companyId,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setHiddenMoving(false)
    }
  }

  const handleTrash = async () => {
    try {
      setTrashMoving(true)
      if (contentId) {
        const {
          data: { success, errors },
        } = await updateIsHiddenOrTrash(
          dataroom_contentId,
          false,
          is_trash !== 'all' ? false : true
        )
        if (success) {
          getDataRoomContentByparentId()
          if (is_trash === 'all') {
            toast.success(formatMessage({ id: 'Moved to trash successfully' }))
          } else {
            toast.success(formatMessage({ id: 'Moved to all files successfully' }))
          }
          setShowTrashModal(null)
          getDataRoomContentById()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DataRoomContentTrashSuccessful,
              action: 'normal',
              metadata: {
                dataroom_content_id: dataroom_contentId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                dataroom_content_is_trash: is_trash !== 'all' ? false : true,
                company_id: companyId,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DataRoomContentTrashFailed,
              action: 'normal',
              metadata: {
                dataroom_content_id: dataroom_contentId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                dataroom_content_is_trash: is_trash !== 'all' ? false : true,
                company_id: companyId,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setTrashMoving(false)
    }
  }

  return (
    <>
      {isOpen ? (
        <div className={`menu menu-sub menu-sub-dropdown data-room-option-dropdown${mode === 'dark' ? '-dark' : ''} show`}>
          {/* <div
            className='option-padding'
            onClick={() => {
              setMenuOpen(null)
              setShowDrawer(true)
              setFilesContentId(contentId)
            }}
          >
            <p className='mb-0'>{formatMessage({id: 'Add more files'})}</p>
          </div>
          <div className='separator border-gray-200'></div> */}
          {!addFilesBool && (
            <>
              <div
                className={`option-padding${mode === 'dark' ? '-dark' : ''}`}
                onClick={() => {
                  setMenuOpen(null)
                  setIsHidden(true)
                  setShowHiddenModal(contentId)
                }}
              >
                <p className='mb-0'>
                  {formatMessage({
                    id: is_hidden === 'all' ? 'Move to Hidden' : 'Move to All Files',
                  })}
                </p>
              </div>
              <div className='separator border-gray-200'></div>
              <div
                className={`option-padding${mode === 'dark' ? '-dark' : ''}`}
                onClick={() => {
                  setMenuOpen(null)
                  setDeleteShowModal(contentId)
                }}
              >
                {type === ContentTypes.FOLDER && (
                  <p className='mb-0 text-danger'>{formatMessage({ id: 'Delete Folder' })}</p>
                )}
                {type === ContentTypes.FILE && (
                  <p className='mb-0 text-danger'>{formatMessage({ id: 'Delete File' })}</p>
                )}
              </div>
              <div className='separator border-gray-200'></div>
              <div
                className={`option-padding${mode === 'dark' ? '-dark' : ''}`}
                onClick={() => {
                  setMenuOpen(null)
                  setIsHidden(false)
                  setShowTrashModal(contentId)
                }}
              >
                <p className={is_trash === 'all' ? 'mb-0 text-danger' : 'mb-0 text-dark'}>
                  {formatMessage({ id: is_trash === 'all' ? 'Move to Trash' : 'Move to All Files' })}
                </p>
              </div>
            </>
          )}
        </div>
      ) : null}

      {/* <div className='option-padding' onClick={() => setShowRenameModal(true)}>
          <p className='mb-0'>{formatMessage({ id: 'Rename' })}</p>
        </div>

        <div className='separator border-gray-200'></div>

        <div className='option-padding' onClick={handleMoveToFolderDROptionClick}>
          <p className='mb-0'>{formatMessage({ id: 'Move to Folder' })}</p>
        </div>
        <div className='separator border-gray-200'></div> */}

      {/* <AddFolderModal
      renameFolderModal={showRenameModal}
      setRenameFolderModal={setShowRenameModal}
      onFolderRename={handleRename}
      renameLoading={isRenamingLoading}
      folderRenameId={contentId}
      newName={newName}
      setNewName={setNewName}
      prevName={name}
      heading={type === ContentTypes.FILE
        ? formatMessage({ id: "Rename File" })
        : formatMessage({ id: "Rename Folder" })}
      labelText={type === ContentTypes.FILE
        ? formatMessage({ id: "Please type the name of your File" })
        : formatMessage({ id: "Please type the name of your Folder" })}
      btnText={formatMessage({ id: 'Save Changes' })}
      showBool={false}
    /> */}
      {/* <MoveFolderModal
     MoveToFolderModal={showMoveToFolderModalDR}
     setMoveToFolderModal={setShowMoveToFolderModalDR}
     moveLoading={isMovingDR}
     toBeMovedId={contentId}
     setIsMoving={setIsMovingDR}
     getBreadcrumb={getDataRoomContentByparentId}
     moveToFolderDr={moveToFolderDr}
     setMoveToFolderDr={setMoveToFolderDr}
     changeFunc={true}
    /> */}
      <DeleteConfirmationModal
        showDeleteModal={showDeleteModal === contentId}
        setDeleteShowModal={() => setDeleteShowModal(null)}
        headingMessage={
          type === ContentTypes.FILE
            ? formatMessage({ id: 'Delete File' })
            : formatMessage({ id: 'Delete Folder' })
        }
        description={
          type === ContentTypes.FILE
            ? formatMessage({ id: 'Are you sure you want to delete this file?' })
            : formatMessage({ id: 'Are you sure you want to delete this folder?' })
        }
        handleDelete={handleDeleteContentDr}
        deleteLoading={deleteLoading}
        id={dataroom_contentId}
      />
      <HiddenOrTrash
        setHiddenTrashModal={isHidden === true ? setShowHiddenModal : setShowTrashModal}
        hiddenTrashModal={
          isHidden === true ? showHiddenModal === contentId : showTrashModal === contentId
        }
        onMoving={isHidden ? handleHidden : handleTrash}
        hiddenTrashLoading={isHidden ? hiddenMoving : trashMoving}
        mainText={
          isHidden === true
            ? formatMessage({
              id:
                'Are you sure you want to move this to ' +
                (is_hidden === 'all' ? 'hidden' : 'all files') +
                '?',
            })
            : formatMessage({
              id:
                'Are you sure you want to move this to ' +
                (is_trash === 'all' ? 'trash' : 'all files') +
                '?',
            })
        }
        heading={formatMessage({ id: 'Please confirm' })}
        btnText={
          isHidden === true
            ? formatMessage({ id: 'Move to ' + (is_hidden === 'all' ? 'Hidden' : 'All Files') })
            : formatMessage({ id: 'Move to ' + (is_trash === 'all' ? 'Trash' : 'All Files') })
        }
        showBool={isHidden ? true : false}
        is_hidden={is_hidden}
        is_trash={is_trash}
      />
    </>
  )
}
